<!-- picker选择框框 -->
<template>
  <div class="form_picker_wrap text_a_left bd_c_f margin_b_10">
    <div
      class="form_item_name"
      :class="option.isRequire ? 'form_item_isNeed' : ''"
      v-if="layout === 'vertical'"
    >
      {{ option.label }}
    </div>
    <div
      v-if="option.hasDescription && layout === 'vertical'"
      class="form_item_desc"
    >
      {{ option.description }}
    </div>
    <van-divider v-if="layout === 'vertical'" />
    <van-cell-group>
      <van-field
        :label="layout === 'horizontal' ? option.label : null "
        :class="layout === 'horizontal' ? (option.isRequire ? 'form_item_horizontal_isNeed' : '') : '' "
        v-model="option.value"
        is-link
        readonly
        :disabled="option.cannotEdit"
        :placeholder="option.placeholder"
        @click="handlePick"
        :name="option.name"
        :error-message="errorMessage"
        :rules="[
          {
            validator: asyncValidator,
            message: $t('book.validator.require')
          }
        ]"
      />
    </van-cell-group>
    <van-popup
      v-model="show"
      :get-container="getContainer"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'FromPicker',
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    layout: {
      type: String,
      default: "horizontal" // horizontal 水平 vertical 垂直
    }
  },
  data() {
    return {
      show: false,
      error: false,
      errorMessage: '',
      columns: [
        // '男',
        // '女',
        // '保密',
        // '我想查看当一条记录文字过多时，该内容会如何展示在页面当中'
      ]
    }
  },

  components: {},
  watch: {
    option: {
      handler(value) {
        let tempDataArr = value.options
        let tempArr = []
        tempDataArr.map(item => {
          tempArr.push(item.label)
        })

        this.columns = tempArr
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    //格式校验方法
    asyncValidator(value) {
      return new Promise(resolve => {
        if (value.length > 0) {
          resolve(this.SetCheckSuccMsg())
        } else {
          if (this.option.isRequire) {
            resolve(this.SetCheckErrorMsg(this.$t('form.validator.require')))
          } else {
            resolve(this.SetCheckSuccMsg())
          }
        }
      })
    },
    // 设置校验不通过提示内容
    SetCheckErrorMsg(msg) {
      this.error = true
      this.errorMessage = msg
      return false
    },
    // 设置校验通过提示内容
    SetCheckSuccMsg() {
      this.error = false
      this.errorMessage = ''
      return true
    },
    // 设置popup挂载点
    getContainer() {
      return document.querySelector('.form_picker_wrap')
    },
    // 开始选择
    handlePick() {
      if (!this.option.cannotEdit) {
        this.show = true
      }

    },
    onConfirm(value) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      // console.log(value)
      this.$emit('listenPickerValueChange', this.option.name, value)
      this.asyncValidator(this.option.value)
      this.show = false
    },
    onCancel() {
      this.show = false
    }
  },

  mounted() { }
}
</script>
<style lang="less" scoped></style>
